(() => {
  const tab = document.querySelector('.hp-offer-tab');
  const offer = document.querySelector('.hp-promotion');
  if (!tab || !offer || tab.dataset.ready) return;
  tab.dataset.ready = 'true';
  offer.id = 'hp-print-offer';
  tab.addEventListener('click', event => {
    event.preventDefault();
    offer.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    offer.setAttribute('tabindex', '-1');
    offer.focus({ preventScroll: true });
  });
  // A mobile overlay is only shown where it cannot obscure reading or controls.
  // Re-evaluate while scrolling, including fixed cookie/navigation controls.
  let pending = false;
  const update = () => {
    pending = false;
    if (!matchMedia('(max-width: 800px)').matches) { tab.hidden = false; return; }
    tab.hidden = false;
    const r = tab.getBoundingClientRect();
    const blocked = [...document.querySelectorAll('a,button,input,select,textarea,h1,h2,h3,p,figcaption,[role="dialog"],[role="navigation"]')].some(el => {
      if (el === tab || tab.contains(el)) return false;
      const s = getComputedStyle(el), b = el.getBoundingClientRect();
      return s.visibility !== 'hidden' && s.display !== 'none' && b.width && b.height && b.right > r.left - 6 && b.left < r.right + 6 && b.bottom > r.top - 6 && b.top < r.bottom + 6;
    });
    if (blocked && document.activeElement !== tab) tab.hidden = true;
  };
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(update); } };
  document.addEventListener('scroll', schedule, { capture: true, passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  schedule();
})();
